"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getLabel = getLabel;
var Appdefs = window.cccisd.appDefinitions;
function getLabel(key, handle, defaultValue) {
  var isSingular = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
  try {
    var pawnDef = Appdefs.pawn[key].find(function (def) {
      return def.handle === handle;
    });
    return isSingular ? pawnDef.label : pawnDef.labelPlural;
  } catch (e) {
    return defaultValue;
  }
}